import React from "react";

import Tracker from "./Tracker";

const PageComponent = (props) => {
  return <Tracker {...props} />;
};

export default PageComponent;
